import { render, staticRenderFns } from "./ApplicationsTable.vue?vue&type=template&id=b5e991a6&scoped=true&"
import script from "./ApplicationsTable.vue?vue&type=script&lang=js&"
export * from "./ApplicationsTable.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsTable.vue?vue&type=style&index=0&id=b5e991a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e991a6",
  null
  
)

export default component.exports